export const SIGN_IN = "/signin";
export const SIGN_OUT = "/signout";
export const LANDING = "/";
export const HOME = "/home";
export const ACCOUNT = "/account";
export const BANNERS = "/banners";
export const BANNER_TEMPLATES = "/templates";
export const BANNER_TEMPLATE_NEW = "/templates/new";
export const BANNER_TEMPLATE_COPY = "/templates/copy";
export const BANNER_TEMPLATE_EDIT = "/templates/:bannerTemplateId";
export const FILES = "/files";
export const FILE_EDITOR = "/files/:fileId";
export const ADS = "/ads";
export const ADS_PREVIEWER = "/organization/:organizationId/campaign/:campaignId";
